export default __webpack_public_path__ + "images/25a04340a2a2ed8220ccc98769a81088-drawingandpainting.webp";